(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : factory(global.FillAndSign = {});
})(this, function (exports) {
  'use strict';

  var _frontendUrl = "https://fill.dropandsign.is";

  function setFrontendURL(frontendUrl) {
    _frontendUrl = frontendUrl;
  }

  function getFrontendURL() {
    if (!_frontendUrl || typeof _frontendUrl !== "string") {
      throw new Error("[FillAndSign]: Frontend URL has not been configured properly.");
    }

    return _frontendUrl;
  }

  var _styleUrl;

  function setStyleURL(styleUrl) {
    _styleUrl = styleUrl;
  }

  function getStyleURL() {
    return _styleUrl || getFrontendURL() + "/styles.css";
  }

  function enableScroll() {
    document.body.style.overflow = "";
  }

  function removeFromParent(el) {
    el && el.parentNode && el.parentNode.removeChild(el);
  }

  function getDocumentURL(fileKey, _a) {
    var _b = (_a === void 0 ? {} : _a).smartForm,
        smartForm = _b === void 0 ? false : _b;
    return getFrontendURL() + "/s/" + fileKey + (smartForm ? "?smartForm=true" : "");
  }

  function hasFillAndSignCSSLoaded() {
    var el = document.createElement("div");
    el.setAttribute("class", "fillandsign__cssLoaded");
    document.body.appendChild(el);
    var hasLoaded = window.getComputedStyle(el).display === "none";
    removeFromParent(el);
    return hasLoaded;
  }

  function insertElementIntoDOM(el) {
    var id = el.getAttribute("id");

    if (id) {
      var existingEl = document.getElementById(id);

      if (existingEl) {
        removeFromParent(existingEl);
      }
    }

    document.body.appendChild(el);
  }

  function openDocumentInNewTab(fileKey, options) {
    var _a;

    var win = window.open(getDocumentURL(fileKey, options), "_blank");
    (_a = win) === null || _a === void 0 ? void 0 : _a.focus();
  }

  var FillAndSignIds;

  (function (FillAndSignIds) {
    FillAndSignIds["Modal"] = "fillandsign__modal";
    FillAndSignIds["ModalBackground"] = "fillandsign__modalBackground";
    FillAndSignIds["MisclickCapture"] = "fillandsign__misclickCapture";
    FillAndSignIds["Iframe"] = "fillandsign__iframe";
  })(FillAndSignIds || (FillAndSignIds = {}));

  var classnames = {
    modal: "fillandsign__modal",
    modalBackground: "fillandsign__modalBackground",
    misclickCapture: "fillandsign__misclickCapture"
  };

  var _elementToReceiveFocusOnModalClose;

  var hasRegisteredResizeListener = false;

  function registerResizeAndMessageListeners() {
    if (hasRegisteredResizeListener) {
      return;
    }

    window.addEventListener("resize", function () {
      var modal = document.getElementById(FillAndSignIds.Modal);
      var iframe = document.getElementById(FillAndSignIds.Iframe);

      if (!modal || !iframe) {
        return;
      }

      var rect = modal.getBoundingClientRect();
      iframe.style.width = rect.width + "px";
      iframe.style.height = rect.height + "px";
    });
    window.addEventListener("message", function (message) {
      var _a, _b;

      if (((_b = (_a = message) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.type) === "close_fill_and_sign_modal") {
        closeActiveModal();
      }
    });
    hasRegisteredResizeListener = true;
  }

  var _clickOffListener = null;

  function addClickOffListener() {
    if (_clickOffListener) {
      window.removeEventListener("click", _clickOffListener);
    }

    var listener = function listener(e) {
      var _a;

      if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.getAttribute("id")) === FillAndSignIds.MisclickCapture) {
        return;
      }

      closeActiveModal();
      window.removeEventListener("click", listener);
      _clickOffListener = listener;
    };

    _clickOffListener = listener;
    setTimeout(function () {
      window.addEventListener("click", listener);
    }, 250);
  }

  function createIframeElement(src, rect) {
    var iframe = document.createElement("iframe");
    iframe.setAttribute("id", FillAndSignIds.Iframe);
    iframe.setAttribute("src", src);
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.setAttribute("onload", "this.contentWindow.focus()");
    iframe.style.width = rect.width + "px";
    iframe.style.height = rect.height + "px";
    return iframe;
  }

  function createModalElement() {
    var modal = document.createElement("div");
    modal.setAttribute("id", FillAndSignIds.Modal);
    modal.setAttribute("class", classnames.modal + " " + classnames.modal + "--active");
    return modal;
  }

  function createModalBackgroundElement() {
    var modalBackground = document.createElement("div");
    modalBackground.setAttribute("id", FillAndSignIds.ModalBackground);
    modalBackground.setAttribute("class", classnames.modalBackground + " " + classnames.modalBackground + "--active");
    return modalBackground;
  }

  function createMisclickCaptureElement() {
    var misclickCapture = document.createElement("div");
    misclickCapture.setAttribute("id", FillAndSignIds.MisclickCapture);
    misclickCapture.setAttribute("class", classnames.misclickCapture);
    return misclickCapture;
  }

  function closeActiveModal() {
    if (_clickOffListener) {
      window.removeEventListener("click", _clickOffListener);
      _clickOffListener = null;
    }

    var modal = document.getElementById(FillAndSignIds.Modal);
    var modalBackground = document.getElementById(FillAndSignIds.ModalBackground);
    var misclickCapture = document.getElementById(FillAndSignIds.MisclickCapture);
    modal && modal.setAttribute("class", classnames.modal);
    modalBackground && modalBackground.setAttribute("class", classnames.modalBackground);
    enableScroll();
    setTimeout(function () {
      var _a;

      removeFromParent(modal);
      removeFromParent(modalBackground);
      removeFromParent(misclickCapture);

      if (typeof ((_a = _elementToReceiveFocusOnModalClose) === null || _a === void 0 ? void 0 : _a.focus) === "function") {
        _elementToReceiveFocusOnModalClose.focus();

        _elementToReceiveFocusOnModalClose = null;
      }
    }, 290);
  }

  function openDocumentInModal(fileKey, options) {
    if (options === void 0) {
      options = {};
    }

    var elementToReceiveFocusOnClose = options.elementToReceiveFocusOnClose,
        _a = options.smartForm,
        smartForm = _a === void 0 ? false : _a;

    if (!hasFillAndSignCSSLoaded()) {
      console.warn("[FillAndSign]: Modal did not open because FillAndSign CSS has not loaded. " + "Opening the document in a new tab instead.");
      openDocumentInNewTab(fileKey);
      return;
    }

    var modal = createModalElement();
    var modalBackground = createModalBackgroundElement();
    var misclickCapture = createMisclickCaptureElement();
    insertElementIntoDOM(modal);
    insertElementIntoDOM(modalBackground);
    insertElementIntoDOM(misclickCapture);
    var iframe = createIframeElement(getDocumentURL(fileKey, {
      smartForm: smartForm
    }), modal.getBoundingClientRect());
    modal.appendChild(iframe);
    addClickOffListener();
    registerResizeAndMessageListeners();
    _elementToReceiveFocusOnModalClose = elementToReceiveFocusOnClose || null;
  }

  function openDocument(fileKey, options) {
    var isMobile = innerWidth <= 768;

    if (isMobile) {
      openDocumentInNewTab(fileKey, options);
    } else {
      openDocumentInModal(fileKey, options);
    }
  }

  var registerFileKeyElements = function registerFileKeyElements() {
    var items = document.querySelectorAll("[data-filekey]");

    var _loop_1 = function _loop_1(i) {
      var el = items[i];
      var fileKey = el.getAttribute("data-filekey");
      var smartForm = el.hasAttribute("data-has-smartform");

      if (el.getAttribute("data-filekey-listener-added") === "true") {
        return "continue";
      }

      if (!fileKey) {
        console.error("[FillAndSign]: Found element with [data-filekey] but no value.");
        return "continue";
      }

      el.addEventListener("click", function () {
        openDocument(fileKey, {
          elementToReceiveFocusOnClose: el,
          smartForm: smartForm
        });
      });
      el.setAttribute("data-filekey-listener-added", "true");
    };

    for (var i = 0; i < items.length; i += 1) {
      _loop_1(i);
    }
  };

  exports.setFrontendURL = setFrontendURL;
  exports.getFrontendURL = getFrontendURL;
  exports.getStyleURL = getStyleURL;
  exports.setStyleURL = setStyleURL;
  exports.openDocumentInNewTab = openDocumentInNewTab;
  exports.openDocument = openDocument;
  exports.getDocumentURL = getDocumentURL;
  exports.registerFileKeyElements = registerFileKeyElements;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});